import styled from 'styled-components/macro';

import Text from 'components/Text/Text';

const ErrorText = styled(Text)`
  font-size: 0.875rem;
  color: ${(props) => props.theme.colors.status.error};

  :not(:empty) {
    margin-top: 0.5rem;
  }
`;

export default ErrorText;
